export default "__VITE_ASSET__8txcolTi__"